
//用户的基本信息
export const useUserInfo = defineStore('userInfo', {
    state: () => ({
        id: 0,
        name: '', //用户昵称
        phone: '', //用户手机号
        credit: ''//学分
    }),
    actions: {
        //更新用户信息
        updateUserInfo(phone: string) {
            
            this.phone = phone
        }
    },
    getters: {
        //获取手机号
        getPhoneNumber(): string {
            const phoneCookie = useCookie('phone');
            if(phoneCookie.value){
                return phoneCookie.value
            }
            return this.phone;
        }
    }
})